import apis from './apis';
import {
  OAuthRequestAuthorize,
  OAuthParamsLogin,
  OAuthConsent,
  OAuthCallBack,
  OAuthTokenParams
} from '@/types/OAuth';
import { GenericRestApiFactory } from '@/types/Api';

const apisOAuth = (restFactory: GenericRestApiFactory) => ({
  ...restFactory('oauth'),
  authorize: (params: OAuthRequestAuthorize) =>
    apis.get(`/oauth/authorize`, { params }),
  login: (params: OAuthParamsLogin) => apis.post(`/oauth/login`, params),
  callback: () => apis.get(`/oauth/callback`),
  consent: {
    index: () => apis.get<OAuthConsent>(`/oauth/consent`),
    create: () => apis.post<OAuthCallBack>(`/oauth/consent`),
    delete: () => apis.delete(`/oauth/consent`)
  },
  token: (params: OAuthTokenParams) => apis.post(`/oauth/token`, params)
});

export default apisOAuth;
